<!-- @format -->
<template>
    <base-layout :group="group" group-title="LETTERS" :show-subtitle="false" show-authors show-snippet10>
        <template slot="groupImage">
            <figure class="image">
                <img :src="imageUrl('sections/letters.jpg')" alt="Letters image" />
            </figure>
        </template>
    </base-layout>
</template>

<script>
import { mediaMixin } from '@/mixins/MediaMixin.js';
import BaseLayout from './BaseLayout.vue';

export default {
    components: {
        BaseLayout
    },

    mixins: [mediaMixin],

    props: {
        group: {
            type: Array,
            required: true
        }
    }
};
</script>
